import React, { useState } from "react";
import {
    commonService,
    AppConfigData,
} from "../_services/common.service";
import _Skeleton, { _SkeletonType } from "./_Skeleton";
import _NoDataFound from "./_NoDataFound";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Table from "react-bootstrap/Table";

function Emergency() {

    const history = useHistory();
    let data = commonService.getLoginUserData();
    const params = new URLSearchParams(window.location.search);
    const [emergency, setEmergency] = useState({
        IsData: false,
        data: [],
    });


    React.useEffect(() => {
        getEmergency();
    }, []);

    function getEmergency() {
        setEmergency({ IsData: false, data: [] });
        const req = {
            method: "POST",
            headers: commonService.getHeaders(),
        };
        fetch(AppConfigData.APIBasePath + "v1/home/getemergencylist", req)
            .then((response) => response.json())
            .then(function (json) {
                if (json.status_code === 1) {
                    setEmergency({ IsData: true, data: json.data });
                } else if (json.status_code === 0) {
                    setEmergency({ IsData: true, data: [] });
                } else if (json.status_code === 2) {
                    localStorage.clear();
                    history.push("/");
                }
            });
    }

    return (
        <>
            <h1 className="page-header my-4">Emergency Notice</h1>
            {!emergency.IsData ? (
                <div className="row col-12">
                    <_Skeleton type={_SkeletonType.Table} count={4} lineheight={30} />
                </div>
            ) : emergency.data.length === 0 ? (
                <div className="col-12">
                    <_NoDataFound fontsize={"150px"} />
                </div>
            ) : (
                <Table responsive className="fees-payment-table m-0">
                    <thead>
                        <tr>
                            <th className="w-75px text-center">Sr No.</th>
                            <th>Emergency Notice </th>
                        </tr>
                    </thead>
                    <tbody>
                        {emergency.data.map(
                            (item, index) =>
                                <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    <td>
                                        {item.Type === "Notice" ? (
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: item.Details
                                                }}
                                            />
                                        ) : (
                                            <span>{item.Details}</span>
                                        )}
                                    </td>
                                </tr>
                        )}
                    </tbody>
                </Table>
            )
            }
        </>
    );
}

export default Emergency;
